import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	postInventaireConsommable,
	postInventaireConsommableReset,
	deleteInventaireConsommable,
	deleteInventaireConsommableReset,
} from "../../../store/actions/atelierInventaireActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'une catégorie de consommable (modal V2). POST/DELETE renvoient la
// liste fraîche → le reducer met `consommables` à jour seul. La suppression est
// refusée côté back (FK PROTECT) si le consommable a déjà servi.
const ConsommableModalV2 = ({ consommable, onClose }) => {
	const dispatch = useDispatch()
	const postState = useSelector((s) => s.atelierInventaire.postConsommable)
	const deleteState = useSelector(
		(s) => s.atelierInventaire.deleteConsommable,
	)
	const isCreate = !consommable.id
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [label, setLabel] = useState(consommable.label || "")

	useEffect(() => {
		if (!postState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(postInventaireConsommableReset())
			dispatch(deleteInventaireConsommableReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(postInventaireConsommableReset())
			dispatch(deleteInventaireConsommableReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	const invalid = !label.trim()

	const save = () =>
		dispatch(
			postInventaireConsommable(
				JSON.stringify({
					id: consommable.id || null,
					label: label.trim(),
				}),
			),
		)
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(
			deleteInventaireConsommable(JSON.stringify({ id: consommable.id })),
		)
	}

	const busy =
		postState.saving ||
		postState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = []
	if (!isCreate) {
		buttons.push({
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ?"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		})
	}
	buttons.push({
		title: "Annuler",
		styleName: "secondary",
		onClick: onClose,
		disabled: busy,
	})
	buttons.push({
		title: postState.saving ? (
			<FontAwesomeIcon icon={faSync} spin />
		) : postState.saved ? (
			<FontAwesomeIcon icon={faCheck} />
		) : (
			"Enregistrer"
		),
		styleName: "primary",
		onClick: save,
		disabled: busy || invalid,
	})

	return (
		<CustomModal
			title={
				isCreate ? "Nouveau consommable" : "Éditer le consommable"
			}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>
						Nom<span style={{ color: COLORS.danger }}> *</span>
					</label>
					<input
						style={gs.input}
						value={label}
						onChange={(e) => setLabel(e.target.value)}
						autoFocus
					/>
				</div>
			</div>
		</CustomModal>
	)
}

export default ConsommableModalV2
